import { z } from 'zod';

/**
 * Reusable zod атомы — единые сообщения и regex'ы для форм.
 *
 * Используется в:
 * - lib/schemas/auth.ts — emailSchema
 * - lib/schemas/company.ts — innSchema, ogrnSchema, kppSchema, optionalEmailSchema, phoneSchema, hexColorSchema
 * - lib/schemas/fields.ts — uuidSchema
 *
 * Закрывает Nielsen heuristic 5 (Error prevention) — inline validation
 * до submit, вместо silent backend reject.
 */

/** Email — обязательный, RFC-формат через z.string().email(). */
export const emailSchema = z
  .string()
  .min(1, 'Email обязателен')
  .email('Введите корректный email');

/** Опциональный email — если задан, должен быть валиден. */
export const optionalEmailSchema = z
  .string()
  .optional()
  .or(z.literal(''))
  .refine(
    (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
    'Введите корректный email',
  );

/** ИНН — 10 (юр.лицо) или 12 (ИП) цифр. */
export const innSchema = z
  .string()
  .optional()
  .or(z.literal(''))
  .refine((v) => !v || /^\d{10}$|^\d{12}$/.test(v), 'ИНН: 10 или 12 цифр');

/** ОГРН — 13 (юр.лицо) или 15 (ИП) цифр. */
export const ogrnSchema = z
  .string()
  .optional()
  .or(z.literal(''))
  .refine((v) => !v || /^\d{13}$|^\d{15}$/.test(v), 'ОГРН: 13 или 15 цифр');

/** КПП — ровно 9 цифр. */
export const kppSchema = z
  .string()
  .optional()
  .or(z.literal(''))
  .refine((v) => !v || /^\d{9}$/.test(v), 'КПП: 9 цифр');

/** UUID v4 (UUID без дефисов / в любом case'е тоже принимаются — стандартный z.uuid()). */
export const uuidSchema = z.string().uuid('Неверный UUID');

/** Hex color (#rrggbb или #rgb). */
export const hexColorSchema = z
  .string()
  .regex(/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, 'Hex-цвет: #rgb или #rrggbb');

/** Phone — нестрогий (допустимы пробелы, скобки, дефис, + впереди), 7-20 цифр/знаков. */
export const phoneSchema = z
  .string()
  .optional()
  .or(z.literal(''))
  .refine(
    (v) => !v || /^\+?[\d\s()\-]{7,20}$/.test(v),
    'Введите корректный телефон',
  );
